import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { tagHotjarRecording } from '../../helpers/util'
import useRequest from '../../hooks/useRequest'
import ContentLayout from '../../components/ContentLayout/ContentLayout'
import { useHistory } from 'react-router-dom'
import CardInfo from '../../components/CardInfo/CardInfo'
import InfoLine from '../../components/CardInfo/components/InfoLine'
import CustomDivider from '../../components/CardInfo/components/CustomDivider'
import CellLocation from '../../components/Table/components/CellLocation'
import useGlobalLoading from '../../hooks/useGlobalLoading'

const ViewRentalRequestPage = props => {
    const { match } = props

    const [request, setRequest] = useState([])
    const { handleGetRequestInfo } = useRequest()
    const { changeLoading } = useGlobalLoading()
    const history = useHistory()

    const onGetRequestInfoSuccess = response => {
        let requestInfo = response.data.request
        setRequest(requestInfo)
        changeLoading(false)
    }

    const onGetRequestInfoError = () => {
        tagHotjarRecording('API Error')
        // let message = error.response.data.message
        // setError(message)
        changeLoading(false)
    }

    useEffect(() => {
        let requestId = match?.params?.requestId
        changeLoading(true)
        handleGetRequestInfo(
            requestId,
            'rental',
            onGetRequestInfoSuccess,
            onGetRequestInfoError,
        )
    }, [])

    const renderHeader = () => {
        return (
            <div className="w-full h-auto flex flex-col items-start justify-start p-4 bg-white border-b border-grayLines lg:gap-4 gap-2">
                <p
                    role="button"
                    onClick={() => {
                        history?.goBack()
                    }}
                    className="text-textDarkGray text-sm font-medium"
                >
                    {'< Go Back'}
                </p>
                <p className="text-black90 font-semibold text-lg">
                    Details of {request?.label}
                </p>
            </div>
        )
    }

    const renderRequestInformationContent = () => {
        return (
            <div className="w-full h-auto flex flex-col items-start justify-start py-2">
                <InfoLine
                    label="Type of Request"
                    value={request?.typeDisplay || '-'}
                />
                <CustomDivider />
                <InfoLine
                    label="Submitted by"
                    value={request?.contactName || '-'}
                />
                <CustomDivider />
                <InfoLine
                    label="Submitted on"
                    value={request?.formattedDate || '-'}
                />
                <CustomDivider />
                <InfoLine
                    label="Location"
                    value={
                        (
                            <CellLocation
                                isInCard
                                key="assetLocation"
                                address={request?.address || '-'}
                                label={request?.locationName || '-'}
                            />
                        ) || '-'
                    }
                    isLast
                />
            </div>
        )
    }

    const renderRequestDescriptionContent = () => {
        return (
            <div className="w-full h-auto flex flex-col items-start justify-start py-2">
                <InfoLine
                    label="Description"
                    value={request?.description || '-'}
                />
                <CustomDivider />
                <InfoLine
                    label="From"
                    value={request?.descritpionInfo?.fromDate || '-'}
                />
                <CustomDivider />
                <InfoLine
                    label="To"
                    value={request?.descritpionInfo?.toDate || '-'}
                />
                <CustomDivider />
                <InfoLine
                    label="How Many"
                    value={request?.descritpionInfo?.requestedQuantity || '-'}
                    isLast
                />
            </div>
        )
    }

    const renderContentInfo = () => {
        return (
            <div className="lg:w-220 w-full m-auto h-auto flex flex-col items-start justify-start gap-6 lg:mt-12 lg:p-0 p-4">
                <CardInfo
                    title="Request Information"
                    content={renderRequestInformationContent()}
                />
                <CardInfo
                    title="Request Description"
                    content={renderRequestDescriptionContent()}
                />
            </div>
        )
    }

    return (
        <ContentLayout>
            {renderHeader()}
            {renderContentInfo()}
        </ContentLayout>
    )
}

ViewRentalRequestPage.propTypes = {
    match: PropTypes.shape({
        params: PropTypes.shape({
            requestId: PropTypes.string,
        }),
    }),
    location: PropTypes.shape({
        state: PropTypes.shape({
            source: PropTypes.string,
        }),
    }),
}

export default ViewRentalRequestPage
